import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { CommonModal } from '../../../../global/modal/common/common-modal';
import KnovioPreviewLinkPopoverVM from './knovio-preview-link-popover.viewmodel';
import { DefaultCloseModalButton } from '../../../../global/modal/common/common-close-modal-buttons';
import DefaultButton from '../../../../global/default-button/default-button';
import './knovio-preview-link-popover.scss';
import KnovioPreviewSpinner from '../../../../global/spinner/knovio-preview-spinner';
import { CopyButton } from '../../../../global/copy-button/copy-button';
import classNames from 'classnames';
import { COPY_LINK, LAUNCH_PREVIEW, LOADING_PREVIEW, PREVIEW_LINK_LOADED } from './knovio-preview-link-popover.text';

interface IKnovioPreviewLinkPopover {
    vm: KnovioPreviewLinkPopoverVM;
}

const KnovioPreviewLinkPopover = observer(({ vm }: IKnovioPreviewLinkPopover) => {
    const {
        intl,
        isPopoverOpened,
        closePopover,
        openKnovioPreviewLink,
        isDisabled,
        isLinkLoading,
        knovioPreviewLink
    } = vm;

    useEffect(() => {
        if (!vm?.isPopoverOpened) return;
        vm?.fetchPreviewLink();
    }, [vm?.isPopoverOpened]);

    return vm ? (
            <CommonModal
                isOpen={isPopoverOpened}
                className='knovio-preview-link-popover'
                classNameBody='knovio-preview-link-popover__body'
                onRequestClose={closePopover}
                supressRenderingCrossIcon
                footer={
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultButton
                                modifier={['fat', 'confirm-safe']}
                                onClick={openKnovioPreviewLink}
                                text={intl.formatMessage(LAUNCH_PREVIEW)}
                                disabled={isDisabled}
                        />
                        <CopyButton
                            className={classNames('copy-link-btn', {
                                'copy-link-btn--disabled': isDisabled,
                            })}
                            text={intl.formatMessage(COPY_LINK)}
                            copyValue={knovioPreviewLink}
                            disabled={isDisabled}
                            withoutIcon
                        />
                        <DefaultCloseModalButton/>
                    </div>
                }
            >
                <div>
                    {isLinkLoading ?
                     <div className='knovio-preview-link-popover__loader'>
                        <KnovioPreviewSpinner/>
                        <div className='oe-form-field__info'>
                            {intl.formatMessage(LOADING_PREVIEW)}
                        </div>
                    </div>
                    : <div className='knovio-preview-link-popover__success-message'>
                        <div className='oe-form-field__info'>
                            {intl.formatMessage(PREVIEW_LINK_LOADED)}
                        </div>
                    </div>}
                </div>
            </CommonModal>
    ) : null;
});

export default KnovioPreviewLinkPopover;
